import React from 'react';
import { MapPin, Building, Warehouse } from 'lucide-react';
import LocationManager from '../components/locations/LocationManager';

const LocationsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Hero Banner */}
      <div className="overflow-hidden rounded-lg">
        <div className="relative">
          <img
            src="https://images.pexels.com/photos/1267338/pexels-photo-1267338.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
            alt="Large warehouse with organized storage racks and inventory locations"
            className="w-full h-64 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30 flex items-center">
            <div className="px-8 text-white">
              <h1 className="text-3xl font-bold mb-2">Storage Locations</h1>
              <p className="text-lg opacity-90">
                Manage your warehouse and storage locations efficiently
              </p>
              <div className="mt-4 flex items-center space-x-6 text-sm">
                <div className="flex items-center">
                  <MapPin className="h-4 w-4 mr-2" />
                  <span>Multi-location Support</span>
                </div>
                <div className="flex items-center">
                  <Building className="h-4 w-4 mr-2" />
                  <span>Warehouse Management</span>
                </div>
                <div className="flex items-center">
                  <Warehouse className="h-4 w-4 mr-2" />
                  <span>Inventory Distribution</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <LocationManager />
    </div>
  );
};

export default LocationsPage;